import { allItems, type ItemTargetType } from '@shared/game/items';
import type { InventoryItemMeta, InventoryItemMode } from './inventory-view';

type ItemMetaMode = 'board' | 'warmup-arena';

function itemModeForTargetType(targetType: ItemTargetType, mode: ItemMetaMode): InventoryItemMode {
  switch (targetType) {
    case 'player':
      return 'player-select';
    case 'direction':
    case 'tile':
      return mode === 'warmup-arena' ? 'player-select' : 'skillshot';
    case 'self':
    case 'none':
      return 'self-cast';
  }
}

export function buildInventoryItemMeta(
  mode: ItemMetaMode = 'board',
): Record<string, InventoryItemMeta> {
  const meta: Record<string, InventoryItemMeta> = {};
  for (const item of allItems()) {
    const itemMode =
      mode === 'board' && (item.id === 'lightning_dash' || item.id === 'thunder_fist')
        ? 'path-direction'
        : itemModeForTargetType(item.targetType, mode);
    meta[item.id] = {
      name: item.name,
      description: item.description,
      effectText: item.description,
      iconKey: item.id,
      targetType: item.targetType,
      itemMode,
    };
  }
  return meta;
}
